/**
 * Pexels images come back at large sizes (up to 1200px+) which makes the
 * listing carousels slow to paint. Rewrite the URL to request a compressed,
 * correctly sized variant from the Pexels CDN.
 */
export function pexelsSrc(url: string, width = 480): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    if (!/pexels\.com$/.test(parsed.hostname.replace(/^www\./, ""))) return url;
    parsed.searchParams.set("auto", "compress");
    parsed.searchParams.set("cs", "tinysrgb");
    parsed.searchParams.set("fm", "webp");
    parsed.searchParams.set("q", "60");
    parsed.searchParams.set("fit", "crop");
    parsed.searchParams.set("w", String(width));
    parsed.searchParams.set("h", String(Math.round((width * 2) / 3)));
    parsed.searchParams.delete("dpr");
    return parsed.toString();
  } catch {
    return url;
  }
}

export function pexelsSrcSet(url: string, widths: number[] = [320, 480, 640]): string {
  if (!url) return "";
  return widths.map((w) => `${pexelsSrc(url, w)} ${w}w`).join(", ");
}
